import React, { useEffect, useState } from "react";
import { Autocomplete, Box, Button, DialogActions, DialogTitle, Checkbox, CircularProgress, Dialog, DialogContent, FormControl, FormControlLabel, FormGroup, IconButton, InputLabel, MenuItem, Select, TextField, Tooltip, Grid, Typography, Paper } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import { Stack } from "@mui/material";
import styled from "styled-components";
import { ACTIVITY_STATUS } from "../../constants";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import OpaqueLoading from "../opaqueLoading/opaqueLoading";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import PartyListModalAddNewRoute from "./PartyListModalAddNewRoute";
import ViewSchoolVisitHistoryModal from "../ViewSchoolVisitHistoryModal";

const StyledDialogContent = styled(DialogContent)`
  padding: 16px;
`;
const StyledDialog = styled(Dialog)`
  // position: relative;
  // max-width: 700px;
`;
const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
    `;
const isMobile = window.innerWidth < 900

const PartyList = ({ onCancel, routeId, routeDate, ownerId, getRouteplanById }) => {

  const [data, setData] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});
  const [openDetailModal, setOpenDetailModal] = useState(false);
  const [fetchCurrentVisitData, setFetchCurrentVisitData] = useState({});
  const [openEditModal, setOpenEditModal] = useState(false);
  const [editVisitType, setEditVisitType] = useState("");
  const [editDate, setEditDate] = useState("");
  const [visitType, setVisitType] = useState([])
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [schoolHistoryData, setSchoolHistoryData] = useState([]);
  const [openHistoryModal, setOpenHistoryModal] = useState(false);
  const [rejectData, setRejectData] = useState(null);
  const [reason, setReason] = useState("");
  const [newOrderStatus, setNewOrderStatus] = useState(0);
  const [refreshKey, setRefreshKey] = useState(0);
  const [openAddRouteModal, setOpenAddRouteModal] = useState(false);

  const today = dayjs();
  const maxDate = today.add(6, 'day');

  const shouldDisableDate = (date) => {
    return date.isBefore(today, 'day') || date.isAfter(maxDate, 'day');
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        let sentData = { id: routeId };
        let results = await window.Platform.database.getRouteplanById(sentData);
        setData(results?.data);
      } catch (error) {
        window.NotificationUtils.showError("Something Went Wrong!");
      } finally {
        setLoading(false);
      }
    };
    if (routeId) fetchData();
  }, [routeId, refreshKey]);

  const formatVisitTime = () => {
    const visit = fetchCurrentVisitData.latestVisit;
    if (!visit) return "N/A";

    const start = new Date(visit.startTime);
    const end = new Date(visit.endTime);

    const optionsDate = { year: "numeric", month: "long", day: "numeric" };
    const optionsTime = { hour: "numeric", minute: "numeric", hour12: true };

    const dateStr = start.toLocaleDateString("en-US", optionsDate);
    const startTimeStr = start.toLocaleTimeString("en-US", optionsTime);
    const endTimeStr = end.toLocaleTimeString("en-US", optionsTime);

    return `${dateStr} (${startTimeStr} - ${endTimeStr})`;
  };

  const fetchCurrentVisit = async (partyId) => {
    setLoading(true);
    let results = await window.Platform.database.fetchCurrentVisit({ partyId });
    if (results?.status) {
      setFetchCurrentVisitData([]);
      // window.NotificationUtils.showError(results?.message);
      setLoading(false);
    } else {
      setFetchCurrentVisitData(results?.data);
      setLoading(false);
    }
  };

  const deleteRouteLineItem = async () => {
    if (!selectedRow?.route_line_items_id) {
      console.warn("route_line_items_id is missing from selectedRow");
      return;
    }
    setLoading(true);

    try {
      const response = await window.Platform.database.deleteOfRoutParty({
        routeLineItemId: selectedRow?.route_line_items_id,
      });
      window.NotificationUtils.showSuccess("Delete Successfully")
      setOpenDetailModal(false);
      setLoading(false);
      if (getRouteplanById) getRouteplanById();
    } catch (error) {
      console.error("Error deleting route line item:", error);
      window.NotificationUtils.showError("Something Went Wrong!")
      setLoading(false);
    }
  };

  const editRouteLineItem = async () => {
    // setOpenEditModal(true);
    // getRouteVisitType()
    setEditVisitType(selectedRow?.visitType || "");
    setEditDate(selectedRow?.date ? dayjs(selectedRow.date) : "");
    setOpenEditModal(true);
    getRouteVisitType();
  }

  const handleCloseEditModal = () => {
    setOpenEditModal(false);
    setEditVisitType("");
    setEditDate("");
  };

  const getRouteVisitType = async (details) => {
    setLoading(true);
    try {
      let results = await window.Platform.database.getRouteVisitType(details);
      setVisitType(results.data)
      setLoading(false)
    }
    catch (err) {
      console.log(err);
      setLoading(false)
    }
  }

  const handleAddNewRoute = () => {
    setOpenAddRouteModal(true);
  };

  const saveEditRouteLineItem = async () => {
    if (!editDate) return window.NotificationUtils.showError("Please Select Date")
    setLoading(true);
    let payload = {
      visitType: editVisitType,
      date: dayjs(editDate).format("YYYY-MM-DD"),
      routeLineItemId: selectedRow?.route_line_items_id,
      owner_id: ownerId
    }
    let results = await window.Platform.database.updateDateOfRoutParty(payload);
    if (results.success) {
      handleCloseEditModal();
      setOpenDetailModal(false);
      onCancel()
      if (getRouteplanById) getRouteplanById();
      window.NotificationUtils.showSuccess("Update Successfully")
      setLoading(false)
    }
    else {
      setLoading(false)
      window.NotificationUtils.showError(results?.message || "Something went wrong")
    }
  }

  const getFilteredData = () => {
    if (newOrderStatus === "") return data;
    return data.filter(row => row.status === newOrderStatus);
  };

  const handleReject = (data, route_line_items_id) => {
    console.log(route_line_items_id, "route_line_items_idroute_line_items_id")
    setRejectData(data);

    setOpenDialog(true);
  };

  const handleConfirmReject = () => {
    if (reason.trim() === "") {
      window.NotificationUtils.showError("Remark is required to reject the order.")
      return;
    }
    approveRejectOrder({ ...rejectData, approvalStatus: "2", reason });
    setOpenDialog(false);
    setReason("");
    setRejectData(null);
  };

  const fetchSchoolHistory = async (row) => {
    console.log(row, "rowrowrow", row.partyId);
    setLoading(true);
    try {
      let data = {
        partyId: row?.partyId,
      };
      let results = await window.Platform.database.fetchSchoolVisitDetails(data);
      if (results?.success) {
        setOpenHistoryModal(true);
        setSchoolHistoryData(results?.data);
        setLoading(false);
      } else {
        window.NotificationUtils.showError(results?.message || "Something went wrong");
        setLoading(false);
      }

    } catch (error) {
      window.NotificationUtils.showError("Something went wrong while fetching school history.");
      setLoading(false);
    }
  }


  const approveRejectOrder = async (val) => {
    const isConfrim = window.confirm("Are you sure you want to " + (val.approvalStatus == "1" ? "approve" : "reject") + " this route plan?");
    if (!isConfrim) return;
    try {
      let message = val.approvalStatus == "1" ? "Route plan approved successfully" : "Route plan rejected successfully";
      setLoading(true)
      let payload = {
        id: val?.id,
        route_line_items_id: val?.route_line_items_id,
        approvalStatus: val?.approvalStatus,
        reason: val?.reason,
        isDirectApproval: false
      }
      // console.log(val, "vallllllllllllll", payload);
      // return;
      const results = await window.Platform.database.approvePartialRouteNotification(payload)
      if (results.status) {
        window.NotificationUtils.showError(results.message);
        setLoading(false)
        return;
      }
      window.NotificationUtils.showSuccess(message);
      setLoading(false)
      setRefreshKey(prev => prev + 1);
    }
    catch (err) {
      console.log(err)
      window.NotificationUtils.showError("Something Went Wrong!");
      setLoading(false)
    }
  }

  const getColumns = () => {
    let result = [
      // {
      //   field: "S.No.",
      //   headerName: "S. No.",
      //   sortable: false,
      //   width: 60,
      //   editable: false,
      //   renderCell: (params) => {

      //     let name = (params.rowIndex ?? params.api?.getRowIndex?.(params.id) ?? 0) + 1;
      //     return (
      //       <Tooltip title={name || "N/A"}>
      //         <Typography variant="inherit">{name}</Typography>{console.log(params,"asdkjhnasdkjsdhaskdkajsdh")}
      //       </Tooltip>
      //     )
      //   },
      // },
      {
        field: "Party Id",
        headerName: "Party ID",
        sortable: false,
        width: 120,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.partyId
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit">{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "itemId",
        headerName: "Party Name",
        sortable: false,
        width: 350,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.partyType == 1 ? params.row?.schoolName : params.row?.DistributorName || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit">{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "Type",
        headerName: "Type",
        sortable: false,
        width: 100,
        editable: false,
        renderCell: (params) => {
          let name = (params.row?.schoolName ? "School" : "Distributor") || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit">{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "Visit Type",
        headerName: "Visit Type",
        width: 180,
        editable: false,
        renderCell: (params) => {
          let name = params.row.visit_type_name || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit">{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "Status",
        headerName: "Status",
        width: 100,
        editable: false,
        renderCell: (params) => {
          let name = params.row.status == 1 ? "Approved" : params?.row?.status == 2 ? "Rejected" : params.row.status == 0 ? "Pending" : "N/A" || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit">{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "Actions",
        headerName: "Actions",
        editable: false,
        hide: true,
        minWidth: 150,
        filterable: false,
        disableExport: true,
        renderCell: (params) => {
          let value = params.row?.routeId;
          let route_line_items_id = params.row?.route_line_items_id;
          return (
            <>
              <Tooltip title="View History">
                <IconButton variant="extended" color="primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    fetchSchoolHistory(params.row);
                  }}
                >
                  <RemoveRedEyeIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Click to approve route-plan"><IconButton disabled={params.row?.status === 1 || params.row?.status === 2} variant="extended" sx={{ color: "#008000" }} onClick={(e) => {
                e.stopPropagation();
                approveRejectOrder({ id: value, approvalStatus: "1", route_line_items_id: route_line_items_id });
              }} >
                <ThumbUpIcon />
              </IconButton></Tooltip>
              <Tooltip title="Click to reject route-plan"><IconButton disabled={params.row?.status === 1 || params.row?.status === 2} variant="extended" sx={{ color: "red" }}
                onClick={(e) => { e.stopPropagation(); handleReject({ id: value, route_line_items_id: route_line_items_id }); }}>
                <ThumbDownIcon />
              </IconButton></Tooltip>
            </>
          );
        },
      },
    ];
    return result
  }

  const renderContent = () => {
    return (
      // <DataGrid
      //   className="payrollGrid"
      //   sx={{ height: isMobile ? "555px" : "522px" }}
      //   density="compact"
      //   rows={data}
      //   columns={getColumns()}
      //   rowHeight={60}
      //   disableSelectionOnClick
      //   disableRowSelectionOnClick
      //   autoPageSize
      //   pageSizeOptions={[10]}
      //   onRowClick={(params) => {
      //     setSelectedRow(params.row);
      //     setOpenDetailModal(true);
      //   }}
      // />
      <DataGrid
        className="payrollGrid"
        sx={{ height: isMobile ? "555px" : "522px" }}
        density="compact"
        // rows={data}
        rows={getFilteredData()}
        columns={getColumns()}
        rowHeight={60}
        disableSelectionOnClick
        disableRowSelectionOnClick
        autoPageSize
        pageSizeOptions={[10]}
        getRowId={(row) => row.route_line_items_id}
        onRowClick={(params) => {
          setSelectedRow(params.row);
          fetchCurrentVisit(params.row?.partyId);
          setOpenDetailModal(true);
        }}
      />
    );
  };

  return (
    <>
      {loading && <OpaqueLoading />}
      <StyledDialog disableEnforceFocus maxWidth="lg" fullWidth={true} open={true} PaperProps={{
        style: {
          minHeight: !isMobile && 600, padding: "10px", borderRadius: "10px", minWidth: isMobile ? 350 : 1080, width: isMobile ? 350 : 1080
        },
      }}>
        <StyledDialogContent>
          <ModalHeaderContainer>
            <div style={{ flex: 1, textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center" }}>
              {/* <Typography variant="h5" style={{ fontWeight: "500", color: "black" }}>
                Route Plan Party - <Tooltip title="Route Date ">{"(" + data.date + ")"}</Tooltip>
              </Typography> */}
              <Typography variant="h5" style={{ fontWeight: "500", color: "black" }}>
                Route Plan Party - <Tooltip title="Route Date ">{routeDate ? `(${routeDate})` : ""}</Tooltip>
              </Typography>
              {/* <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                sx={{ ml: 2, borderRadius: 2, fontWeight: 600, fontSize: 15 }}
                onClick={handleAddNewRoute}
              >
                Add New
              </Button> */}
            </div>
            <IconButton onClick={onCancel}>
              <CloseOutlined />
            </IconButton>
          </ModalHeaderContainer>

          <Button
            onClick={() => setNewOrderStatus("")}
            style={{ backgroundColor: newOrderStatus === "" ? "#8787f470" : "white", color: newOrderStatus === "" ? "#000000" : "black", }}
          >
            All
          </Button>
          <Button
            onClick={() => setNewOrderStatus(0)}
            style={{ backgroundColor: newOrderStatus === 0 ? "#8787f470" : "white", color: newOrderStatus === 0 ? "#000000" : "black", }}
          >
            Pending
          </Button>
          <Button
            onClick={() => setNewOrderStatus(1)}
            style={{ backgroundColor: newOrderStatus === 1 ? "#8787f470" : "white", color: newOrderStatus === 1 ? "#000000" : "black", }}
          >
            Approved
          </Button>
          <Button
            onClick={() => setNewOrderStatus(2)}
            style={{ backgroundColor: newOrderStatus === 2 ? "#8787f470" : "white", color: newOrderStatus === 2 ? "#000000" : "black", }}
          >
            Rejected
          </Button>
          {renderContent()}
        </StyledDialogContent>
      </StyledDialog>

      <Dialog open={openDetailModal} onClose={() => setOpenDetailModal(false)} maxWidth="sm" fullWidth>
        <DialogContent>{console.log(selectedRow, "selectedRowselectedRow")}
          <Paper
            elevation={3}
            sx={{
              p: 1,
              mb: 1,
              width: "100%",
              mx: "auto",
              backgroundColor: "#ebf0fa",
            }}
          >
            <Grid container>
              {/* Row 1 */}
              <Grid item xs={6}>
                <Typography variant="subtitle1" fontWeight="bold">
                  No. Of Visits
                </Typography>
              </Grid>
              <Grid item xs={6} textAlign="right">
                <Typography variant="body1">
                  {fetchCurrentVisitData?.sessionWiseCountVisits || 0}
                </Typography>
              </Grid>

              {/* Row 2 */}
              <Grid item xs={4}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Last Visit
                </Typography>
              </Grid>
              <Grid item xs={8} textAlign="right">
                <Typography variant="body1">
                  {formatVisitTime()}
                </Typography>
              </Grid>
            </Grid>
          </Paper>

          <Typography variant="h6" gutterBottom> Party Detail :- ( {selectedRow?.partyId} )</Typography>
          <Box>
            <Box display="flex" justifyContent="space-between" >
              <Typography sx={{ fontWeight: 600 }}>Name:</Typography>
              <Typography sx={{ fontWeight: 500 }}>
                {selectedRow?.DistributorName || selectedRow?.schoolName || "N/A"}
              </Typography>
            </Box>
            {/* <Typography > <span style={{ fontWeight: "600" }}>Name:  </span><span style={{ fontWeight: "500" }}>{selectedRow?.DistributorName || selectedRow?.schoolName || "N/A"} </span></Typography> */}
            <Box display="flex" justifyContent="space-between" >
              <Typography sx={{ fontWeight: 600 }}>Address:</Typography>
              <Typography sx={{ fontWeight: 500 }}>
                {selectedRow?.AddressLine1 || "N/A"}
              </Typography>
            </Box>
            {/* <Typography > <span style={{ fontWeight: "600" }}>Address. </span><span style={{ fontWeight: "500" }}>{selectedRow?.AddressLine1 || "N/A"} </span></Typography> */}
            <Box display="flex" justifyContent="space-between" >
              <Typography sx={{ fontWeight: 600 }}>Board:</Typography>
              <Typography sx={{ fontWeight: 500 }}>
                {selectedRow?.boardName || "N/A"}
              </Typography>
            </Box>
            {/* <Typography > <span style={{ fontWeight: "600" }}>Board : </span><span style={{ fontWeight: "500" }}>{selectedRow?.boardName || "N/A"} </span></Typography> */}
            <Box display="flex" justifyContent="space-between" >
              <Typography sx={{ fontWeight: 600 }}>Medium:</Typography> <Typography sx={{ fontWeight: 500 }}>{selectedRow?.mediumName || "N/A"}</Typography>
            </Box>
            {/* <Typography > <span style={{ fontWeight: "600" }}>Medium : </span><span style={{ fontWeight: "500" }}>{selectedRow?.mediumName || "N/A"} </span></Typography> */}
            <Box display="flex" justifyContent="space-between" >
              <Typography sx={{ fontWeight: 600 }}>Pincode:</Typography>
              <Typography sx={{ fontWeight: 500 }}>
                {selectedRow?.Pincode || "N/A"}
              </Typography>
            </Box>
            {/* <Typography > <span style={{ fontWeight: "600" }}>Pincode : </span><span style={{ fontWeight: "500" }}>{selectedRow?.Pincode || "N/A"} </span></Typography> */}
          </Box>
          <hr style={{ width: "100%", borderTop: "1px solid black" }} />

          <Typography variant="h6" gutterBottom> Contact Person Detail : </Typography>
          {/* <Box>
            <Typography > <span style={{ fontWeight: "600" }}>Name:  </span><span style={{ fontWeight: "500" }}>{selectedRow?.makerName || "N/A"} </span></Typography>
            <Typography > <span style={{ fontWeight: "600" }}>Role : </span><span style={{ fontWeight: "500" }}>{selectedRow?.decisionMakerRole || "N/A"} </span></Typography>
            <Typography > <span style={{ fontWeight: "600" }}>Contact Number : </span><span style={{ fontWeight: "500" }}>{selectedRow?.makerContact || "N/A"} </span></Typography>
            <Typography > <span style={{ fontWeight: "600" }}>Email : </span><span style={{ fontWeight: "500" }}>{selectedRow?.email || "N/A"} </span></Typography>
          </Box> */}
          <Box>
            <Box display="flex" justifyContent="space-between" >
              <Typography sx={{ fontWeight: 600 }}>Name:</Typography>
              <Typography sx={{ fontWeight: 500 }}>
                {selectedRow?.makerName || "N/A"}
              </Typography>
            </Box>

            <Box display="flex" justifyContent="space-between" >
              <Typography sx={{ fontWeight: 600 }}>Role:</Typography>
              <Typography sx={{ fontWeight: 500 }}>
                {selectedRow?.decisionMakerRole || "N/A"}
              </Typography>
            </Box>

            <Box display="flex" justifyContent="space-between">
              <Typography sx={{ fontWeight: 600 }}>Contact Number:</Typography>
              <Typography sx={{ fontWeight: 500 }}>
                {selectedRow?.makerContact || "N/A"}
              </Typography>
            </Box>

            <Box display="flex" justifyContent="space-between">
              <Typography sx={{ fontWeight: 600 }}>Email:</Typography>
              <Typography sx={{ fontWeight: 500 }}>
                {selectedRow?.email || "N/A"}
              </Typography>
            </Box>
          </Box>


          <hr style={{ width: "100%", borderTop: "1px solid black" }} />

          <Typography variant="h6" gutterBottom> Last Visit Details : </Typography>
          {/* <Box>
            <Typography > <span style={{ fontWeight: "600" }}>Ho Action Needed:  </span><span style={{ fontWeight: "500" }}>{selectedRow?.Pincode || "N/A"} </span></Typography>
            <Typography > <span style={{ fontWeight: "600" }}>Ho Remarks : </span><span style={{ fontWeight: "500" }}>{selectedRow?.AddressLine1 || "N/A"} </span></Typography>
            <Typography > <span style={{ fontWeight: "600" }}>Further Visit Required : </span><span style={{ fontWeight: "500" }}>{selectedRow?.landmark || "N/A"} </span></Typography>
            <Typography > <span style={{ fontWeight: "600" }}>Reason : </span><span style={{ fontWeight: "500" }}>{selectedRow?.landmark || "N/A"} </span></Typography>
          </Box> */}
          <Box>
            <Box display="flex" justifyContent="space-between">
              <Typography sx={{ fontWeight: 600 }}>Ho Action Needed:</Typography>
              <Typography sx={{ fontWeight: 500 }}>
                {/* {fetchCurrentVisitData?.latestVisit?.ho_need ? "Yes" : "No" || "N/A"} */}
                {fetchCurrentVisitData?.latestVisit?.ho_need === "true" ? "Yes" : "No"}
              </Typography>
            </Box>

            <Box display="flex" justifyContent="space-between">
              <Typography sx={{ fontWeight: 600 }}>Ho Remarks:</Typography>
              <Typography sx={{ fontWeight: 500 }}>
                {fetchCurrentVisitData?.latestVisit?.ho_need_remark || "N/A"}
              </Typography>
            </Box>

            <Box display="flex" justifyContent="space-between">
              <Typography sx={{ fontWeight: 600 }}>Further Visit Required:</Typography>
              <Typography sx={{ fontWeight: 500 }}>
                {
                  (() => {
                    const fv = fetchCurrentVisitData?.latestVisit?.furtherVisitRequired;
                    if (!fv) return "N/A";
                    if (typeof fv === "string") {
                      try { return JSON.parse(fv)?.visit_required ?? "N/A"; } catch { return "N/A"; }
                    }
                    if (typeof fv === "object" && fv !== null) return fv.visit_required ?? "N/A";
                    return "N/A";
                  })()
                }
              </Typography>
            </Box>

            <Box display="flex" justifyContent="space-between">
              <Typography sx={{ fontWeight: 600 }}>Reason:</Typography>
              <Typography sx={{ fontWeight: 500 }}>
                {
                  (() => {
                    const fv = fetchCurrentVisitData?.latestVisit?.furtherVisitRequired;
                    if (!fv) return "N/A";
                    if (typeof fv === "string") {
                      try { return JSON.parse(fv)?.reason ?? "N/A"; } catch { return "N/A"; }
                    }
                    if (typeof fv === "object" && fv !== null) return fv.reason ?? "N/A";
                    return "N/A";
                  })()
                }
                {/* {fetchCurrentVisitData?.latestVisit?.furtherVisitRequired} */}
                {/* {fetchCurrentVisitData?.latestVisit?.furtherVisitRequired ? JSON.parse(fetchCurrentVisitData?.latestVisit?.furtherVisitRequired)?.reason : "N/A"  } */}
              </Typography>
            </Box>
          </Box>

          <hr style={{ width: "100%", borderTop: "1px solid black" }} />

          {/* <Box>
            <Typography > <span style={{ fontWeight: "600" }}>Assigned RM :  </span><span style={{ fontWeight: "500" }}>{selectedRow?.Pincode || "N/A"} </span></Typography>
          </Box> */}
          <Box display="flex" justifyContent="space-between" mb={1}>
            <Typography sx={{ fontWeight: 600 }}>Assigned RM:</Typography>
            <Typography sx={{ fontWeight: 500 }}>
              {selectedRow?.ownerName || "N/A"}
            </Typography>
          </Box>
          <Box display="flex" justifyContent="space-between" >
            <Typography sx={{ fontWeight: 500, fontSize: "18px" }}>Extra Details</Typography>
          </Box>
          <Box display="flex" justifyContent="space-between">
            <Typography sx={{ fontWeight: 600 }}>Customer Type :</Typography>
            <Typography sx={{ fontWeight: 500 }}>
              {selectedRow?.customerType || "N/A"}
            </Typography>
          </Box>

          <hr style={{ width: "100%", borderTop: "1px solid black" }} />

          <Typography variant="h6" gutterBottom> Status :- {selectedRow?.visited_status == 0 ? "Visit Pending" : selectedRow?.visited_status == 1 ? "Visit Started" : selectedRow?.visited_status == 2 ? "Meeting Started" : selectedRow?.visited_status == 3 ? "Meeting Ended" : selectedRow?.visited_status == 4 ? "Visit Completed" : "N/A"} </Typography>

          {selectedRow?.visited_status == 0 && <Box className="mt-1" display="flex" gap={2}>
            <Button startIcon={<EditIcon />} variant="outlined" color="primary" onClick={() => editRouteLineItem()}>
              Edit
            </Button>
            <Button startIcon={<DeleteIcon />} variant="outlined" color="error" onClick={deleteRouteLineItem}>
              Delete
            </Button>
          </Box>}

          <Box mt={0} textAlign="right">
            <Button onClick={() => setOpenDetailModal(false)} variant="contained">Close</Button>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog open={openEditModal} onClose={() => setOpenEditModal(false)} maxWidth="xs" PaperProps={{ style: { marginTop: '-20vh' } }} fullWidth>
        <DialogContent>
          <Typography variant="h6" gutterBottom>Edit Party</Typography>
          <Box display="flex" flexDirection="column" gap={2} mt={1}>
            <FormControl fullWidth>
              <InputLabel id="visit-type-label">Visit Type</InputLabel>
              <Select
                labelId="visit-type-label"
                value={editVisitType}
                label="Visit Type"
                onChange={e => setEditVisitType(e.target.value)}
              >
                {visitType && visitType?.map((ele, ind) => {

                  return <MenuItem value={ele?.routeVisitTypeID} key={ind}>{ele?.routeVisitType}</MenuItem>
                })}
              </Select>
            </FormControl>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Select Date"
                value={editDate}
                onChange={(newValue) => setEditDate(newValue)}
                shouldDisableDate={shouldDisableDate}
                disablePast
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>

            <Box display="flex" justifyContent="flex-end" gap={2}>
              <Button onClick={() => setOpenEditModal(false)} variant="outlined">Cancel</Button>
              <Button
                variant="contained"
                onClick={() => saveEditRouteLineItem()}
              >
                Save
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth>
        <DialogTitle>Reject Route Plan</DialogTitle>
        <DialogContent>
          <TextField autoFocus margin="dense" label="Remark" type="text" fullWidth variant="outlined" value={reason} onChange={(e) => setReason(e.target.value)} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmReject} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
      {openAddRouteModal && (
        <PartyListModalAddNewRoute
          open={openAddRouteModal}
          onClose={() => setOpenAddRouteModal(false)}
          routeId={routeId}
          ownerId={ownerId}
          routeDate={routeDate}
        />
      )}
      <Dialog open={openHistoryModal} onClose={() => setOpenHistoryModal(false)} maxWidth="xl" fullWidth>
        <DialogContent>
          <ViewSchoolVisitHistoryModal
            closePopup={() => {
              setOpenHistoryModal(false);
              setSchoolHistoryData([]);
            }}
            modalData={schoolHistoryData}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PartyList;
